// import MoveAnim from '@/components/framer/move-anim';
import { ICPType, UseCaseWhyItMatter } from '@/types/global';
import Image from 'next/image';
import Hyperlink from '../ui/hyperlink';

interface Props {
    data: ICPType | UseCaseWhyItMatter;
}

const ICPAreaCard = ({ data }: Props) => {
    return (
        <>
            <div className="desilo-service-box5">
                <div className="desilo-service-box5 border-0 p-0">
                    {data?.icon && (
                        <div className="desilo-iconbox-icon">
                            <Image
                                height={52}
                                width={52}
                                src={data?.icon}
                                alt="service-icon"
                            />
                        </div>
                    )}
                    <div className="desilo-content h-100">
                        <div className="content-wrapper d-flex flex-column justify-content-between h-100">
                            <div>
                                <h3>{data?.title}</h3>
                                <p>{data?.description}</p>
                                {/* <ul className="mt-4">
                                    {data?.points?.map((point, index) => (
                                        <li className="custom-ul" key={index}>{point}</li>
                                    ))}
                                </ul> */}
                            </div>
                            {data?.link && (
                                <Hyperlink
                                    className="mt-2 mt-lg-5"
                                    href={data.link}
                                    aria-label={`Learn more about our services for ${data.title}`}
                                >
                                    Learn More
                                </Hyperlink>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ICPAreaCard;
